import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgBoxLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M10 1.5a4 4 0 0 1 4 0l6.093 3.518a4 4 0 0 1 2 3.464v7.036a4 4 0 0 1-2 3.464L14 22.5a4 4 0 0 1-4 0l-6.093-3.518a4 4 0 0 1-2-3.464V8.482a4 4 0 0 1 2-3.464zm3 1.732a2 2 0 0 0-2 0L9.67 4l7.094 4.095 2.33-1.345zm2.763 7.75v1.461a.8.8 0 0 0 1.198.694c.496-.286.802-.814.802-1.387V9.827l2.33-1.345v7.036a2 2 0 0 1-1 1.732L13 20.768v-8.19zm-1-1.732L7.67 5.155 4.907 6.75 12 10.845zM3.908 8.482 11 12.577v8.191L4.907 17.25a2 2 0 0 1-1-1.732z'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgBoxLine)
export default ForwardRef
